import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import mainTheme from 'src/styles/Theme'

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: ${(props) => (props.isScrollable ? 'initial' : 'hidden')};
  }

  body {
    font-family: ${(props) => props.theme.font.family.primary};
    font-size: ${(props) => props.theme.font.size.medium};
    color: ${(props) => props.theme.color.dark};
  }

  ${(props) =>
    Object.keys(props.theme.color).map(
      (key) =>
        `.bg-${key} { background-color: ${props.theme.color[key]}; }
        .text-${key} { color: ${props.theme.color[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.family).map(
      (key) =>
        `.font-family-${key} { font-family: ${props.theme.font.family[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.size).map(
      (key) => `.font-size-${key} { font-size: ${props.theme.font.size[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.weight).map(
      (key) =>
        `.font-weight-${key} { font-weight: ${props.theme.font.weight[key]}; }`
    )}

  [data-slot='accordion'] {
    border-top: 1px solid ${(props) => props.theme.color.grey};
  }

  [data-slot='accordion-item'] {
    border-bottom: 1px solid ${(props) => props.theme.color.grey};
  }

  [data-slot='accordion-trigger'] {
    padding: 0.75rem 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    border: 0;
    text-align: left;
    font-size: ${(props) => props.theme.font.size.medium};
    font-weight: ${(props) => props.theme.font.weight.medium};
    color: ${(props) => props.theme.color.dark};
    cursor: pointer;
  }

  [data-slot='accordion-trigger']:hover {
    color: ${(props) => props.theme.color.primary};
  }

  [data-slot='accordion-trigger']:focus-visible {
    outline: 2px solid ${(props) => props.theme.color.primary};
    outline-offset: 2px;
  }

  [data-slot='accordion-trigger'] svg {
    flex-shrink: 0;
    color: ${(props) => props.theme.color.primary};
  }

  [data-slot='accordion-content'] {
    font-size: ${(props) => props.theme.font.size.small};
    color: ${(props) => props.theme.color.dark};
    padding-bottom: 0.75rem;
    overflow: hidden;
  }

  [data-slot='accordion-trigger']
    [data-slot='accordion-trigger-icon-open'] {
    display: none;
  }

  [data-slot='accordion-trigger'][data-state='open']
    [data-slot='accordion-trigger-icon-open'] {
    display: inline-flex;
  }

  [data-slot='accordion-trigger'][data-state='open']
    [data-slot='accordion-trigger-icon-closed'] {
    display: none;
  }

  a {
    color: inherit;

    &:hover {
      color: inherit;
    }
  }
`

const Theme = ({ children, isScrollable = true }) => (
  <ThemeProvider theme={mainTheme}>
    <GlobalStyle isScrollable={isScrollable} />
    {children}
  </ThemeProvider>
)

export default Theme
